import React, { useContext } from 'react';
import ErrorBoundary from '../../../components/react/error_boundary/error_boundary';
import { EventDetailsContext } from '../../context/event_details.context';
import EndDate from '../end_date/end_date';
import EndTime from '../end_time/end_time';
import StartDate from '../start_date/start_date';
import StartTime from '../start_time/start_time';

const DateAndTime: React.FC = () => {
  const { event } = useContext(EventDetailsContext);

  if (!event) return null;

  const renderStartsAtDate = (
    <ErrorBoundary>
      <StartDate />
    </ErrorBoundary>
  );

  const renderSingleDayWithTimeSpan: JSX.Element = (
    <>
      {renderStartsAtDate}
      {' | '}
      <ErrorBoundary>
        <StartTime displayTimezone={false} />
      </ErrorBoundary>
      {' - '}
      <ErrorBoundary>
        <EndTime />
      </ErrorBoundary>
    </>
  );

  const renderMultiDaysEvent: JSX.Element = (
    <>
      {renderStartsAtDate}
      {' - '}
      <ErrorBoundary>
        <EndDate />
      </ErrorBoundary>
    </>
  );

  return (
    <>
      {event.multiDayEvent
        ? renderMultiDaysEvent
        : event.singleDayWithTimespan
        ? renderSingleDayWithTimeSpan
        : renderStartsAtDate}
    </>
  );
};

export default DateAndTime;
